import React from 'react'
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import classNames from 'classnames'

import { NavigationItem, UserImage, Icons } from 'components'
import { strings, users, t } from 'tools'
import config from 'config'

import './navigation.scss'

class Navigation extends React.Component {

    static propTypes = {
        account:     PropTypes.object,
        currentPath: PropTypes.string,
        expanded:    PropTypes.bool,
        canSwitch:   PropTypes.bool,

        onAccountSettings: PropTypes.func,
        onTogglePanel:     PropTypes.func,
        onSwitchAccount:   PropTypes.func,
        onSignOut:         PropTypes.func
    }

    nav = item =>
        {
            const
                { account, currentPath } = this.props,
                Icon = Icons[strings.capitalize( item.slug )],
                active = (
                    item.path === currentPath ||
                    ( item.aliases && item.aliases.indexOf( currentPath ) > -1 )
                )
                
            if ( !users.allowed( account, item ) || users.hide( account, item ) ) return null

            return (
                <li key={item.slug}>
                    <Link to={item.path}>
                        <NavigationItem
                            active = { active }
                            name   = { t(`navigation.${item.name.toLowerCase()}`) }
                            icon   = { <Icon extraClassName="navigation-item-icon" /> }
                        />
                    </Link>
                </li>
            )
        }

    render () {
        const 
            { account, expanded, canSwitch } = this.props,
            { onTogglePanel, onSwitchAccount, onSignOut, onAccountSettings } = this.props,
            cls = classNames(
                'section',
                expanded && 'expanded',
            )

        return (
            <div className="panel-navigation">
                <div className={cls}>

                    <div
                        className = "control user-panel-control"
                        onClick   = { onTogglePanel }
                    >
                        <UserImage src={account.image} fullName={account.name} />
                        <span className="user-name">
                            {account.name}
                        </span>
                    </div>

                    <div className="account-navigation">

                        {/*
                            <NavigationItem
                                extraClassName = {
                                    classNames(
                                        "account-navigation-item",
                                        expanded && 'expanded',
                                    )
                                }

                                name = { t('admin.accountSettings') }
                                icon = { <Icons.Settings extraClassName="navigation-item-icon" /> }

                                onClick = { onAccountSettings }
                            />
                        */}

                        {
                            canSwitch && (
                                <NavigationItem
                                    isParent

                                    extraClassName = {
                                        classNames(
                                            "account-navigation-item",
                                            "parent-navigation-item",
                                            expanded && 'expanded',
                                        )
                                    }
                                    
                                    name = { t('admin.switchAccount') }
                                    icon = { <Icons.Account extraClassName="navigation-item-icon" /> }

                                    onClick = { onSwitchAccount }
                                />
                            )
                        }

                        <NavigationItem
                            extraClassName = {
                                classNames(
                                    "account-navigation-item",
                                    expanded && 'expanded',
                                )
                            }

                            name = { t('admin.signOut') }
                            icon = { <Icons.SignOut extraClassName="navigation-item-icon" /> }

                            onClick = { onSignOut }
                        />

                        <div className="legal-notes account-navigation-item">
                            <span className="copyright">
                                { t('global.poweredBy') }
                                <img src="data:image/png;base64,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" alt="Tabee" />
                            </span>
                        </div>
                    </div>
                </div>

                <div className="section">
                    <nav className="admin-navigation">
                        <ul className="admin-navigation-items">
                            {
                                config.navigation.admin.map( this.nav )
                            }    
                        </ul>
                    </nav>
                </div>
            </div>
        )
    }
}

export default Navigation